const projectsDemos = [
	{
		projectName: 'r1se',
		title: 'R1SE  <br /><br /> Gaming tournament platform',
		thumb: {
			oldgen: {
				small: './media/projects/r1se/thumbs/small.jpg',
				medium: './media/projects/r1se/thumbs/medium.jpg',
				large: './media/projects/r1se/thumbs/large.jpg',
				format: 'jpg',
			},
			nextgen: {
				small: './media/projects/r1se/thumbs/small.webp',
				medium: './media/projects/r1se/thumbs/medium.webp',
				large: './media/projects/r1se/thumbs/large.webp',
			},
			imageFit: 'cover',
			imageAlt: 'Gaming tournament platform',
		},
	},

	{
		projectName: 'acroplia',
		title: 'Acroplia <br /><br /> All-in-one comprehensive collaboration platform',
		thumb: {
			imagePath: {
				path: './media/projects/acroplia/main.jpg',
				format: 'jpg',
				webp: './media/projects/acroplia/main.webp',
			},
			imageFit: 'cover',
			imageAlt: 'Acroplia - collaboration platform',
		},
	},

	{
		projectName: 'nomadcalendar',
		title: 'Nomad Calendar <br /><br /> Travel PWA Application',
		thumb: {
			oldgen: {
				small: './media/projects/nomadcalendar/thumbs/small.jpg',
				medium: './media/projects/nomadcalendar/thumbs/medium.jpg',
				large: './media/projects/nomadcalendar/thumbs/large.jpg',
				format: 'jpg',
			},
			nextgen: {
				small: './media/projects/nomadcalendar/thumbs/small.webp',
				medium: './media/projects/nomadcalendar/thumbs/medium.webp',
				large: './media/projects/nomadcalendar/thumbs/large.webp',
			},
			imageFit: 'cover',
			imagePosition: 'left top',
			imageAlt: 'Travel PWA Application',
		},
	},

	{
		projectName: 'goodgantt',
		title: 'GoodGantt <br /><br /> Multifunctional Chrome extension for Trello',
		thumb: {
			oldgen: {
				small: './media/projects/goodgantt/thumbs/small.png',
				medium: './media/projects/goodgantt/thumbs/medium.png',
				large: './media/projects/goodgantt/thumbs/large.png',
				format: 'png',
			},
			nextgen: {
				small: './media/projects/goodgantt/thumbs/small.webp',
				medium: './media/projects/goodgantt/thumbs/medium.webp',
				large: './media/projects/goodgantt/thumbs/large.webp',
			},
			imageFit: 'cover',
			imagePosition: 'left top',
			imageAlt: 'GoodGantt for Trello',
		},
	},

	{
		projectName: 'hrnetwork',
		title: 'HR Network <br /><br /> Platform for IT recruiters',
		thumb: {
			oldgen: {
				small: './media/projects/hrnetwork/thumbs/small.jpg',
				medium: './media/projects/hrnetwork/thumbs/medium.jpg',
				large: './media/projects/hrnetwork/thumbs/large.jpg',
				format: 'jpg',
			},
			nextgen: {
				small: './media/projects/hrnetwork/thumbs/small.webp',
				medium: './media/projects/hrnetwork/thumbs/medium.webp',
				large: './media/projects/hrnetwork/thumbs/large.webp',
			},
			imageFit: 'cover',
			imagePosition: 'left top',
			imageAlt: 'HR Network',
		},
	},

	{
		projectName: 'electron_webp_converter',
		title: 'WebP Converter <br /><br /> Electron desktop application',
		thumb: {
			imagePath: {
				path: './media/projects/electron_webp_converter/main.jpg',
				format: 'jpg',
				webp: './media/projects/electron_webp_converter/main.webp',
			},
			imageFit: 'fill',
			imageAlt: 'WebP converter - Electron desktop app',
		},
	},

	{
		projectName: 'csvparser',
		title:
			'CSV parsing app <br /><br /> It parses large csv files, displays and filters data',
		thumb: {
			oldgen: {
				small: './media/projects/csvparser/thumbs/small.png',
				medium: './media/projects/csvparser/thumbs/medium.png',
				large: './media/projects/csvparser/thumbs/large.png',
				format: 'png',
			},
			nextgen: {
				small: './media/projects/csvparser/thumbs/small.webp',
				medium: './media/projects/csvparser/thumbs/medium.webp',
				large: './media/projects/csvparser/thumbs/large.webp',
			},
			imageFit: 'fill',
			imageAlt: 'csv parsing app',
		},
	},

	{
		projectName: 'staff',
		title: 'Staff <br /><br /> Сorporate React web service',
		thumb: {
			oldgen: {
				small: './media/projects/staff/thumbs/small.jpg',
				medium: './media/projects/staff/thumbs/medium.jpg',
				large: './media/projects/staff/thumbs/large.jpg',
				format: 'jpg',
			},
			nextgen: {
				small: './media/projects/staff/thumbs/small.webp',
				medium: './media/projects/staff/thumbs/medium.webp',
				large: './media/projects/staff/thumbs/large.webp',
			},
			imageFit: 'cover',
			imagePosition: 'center',
			imageAlt: 'staff web service',
		},
	},

	{
		projectName: 'vk_react_filter',
		title:
			'VK-React filter <br><br>Native vk-app, it scans and filters your vk groups',
		thumb: {
			oldgen: {
				small: './media/projects/vk_react_filter/thumbs/small.png',
				medium: './media/projects/vk_react_filter/thumbs/medium.png',
				large: './media/projects/vk_react_filter/thumbs/large.png',
				format: 'png',
			},
			nextgen: {
				small: './media/projects/vk_react_filter/thumbs/small.webp',
				medium: './media/projects/vk_react_filter/thumbs/medium.webp',
				large: './media/projects/vk_react_filter/thumbs/large.webp',
			},
			imageFit: 'cover',
			imagePosition: 'left bottom',
			imageAlt: 'VK-react group filter',
		},
	},

	{
		projectName: 'travelshop',
		title:
			'The best tours <br /><br /> Traveling online store.<br />Developed with Laravel',
		thumb: {
			imagePath: {
				path: './media/projects/travelshop/main.jpg',
				format: 'jpg',
				webp: './media/projects/travelshop/main.webp',
			},
			imageAlt: 'travel shop',
		},
	},

	{
		projectName: 'poynthq',
		title: 'PoyntHQ <br><br>Dashboard for Payment Terminals',
		thumb: {
			oldgen: {
				small: './media/projects/poynthq/thumbs/small.jpg',
				medium: './media/projects/poynthq/thumbs/medium.jpg',
				large: './media/projects/poynthq/thumbs/large.jpg',
				format: 'jpg',
			},
			nextgen: {
				small: './media/projects/poynthq/thumbs/small.webp',
				medium: './media/projects/poynthq/thumbs/medium.webp',
				large: './media/projects/poynthq/thumbs/large.webp',
			},
			imageFit: 'cover',
			imagePosition: 'left top',
			imageAlt: 'PoyntHQ dashboard',
		},
	},

	{
		projectName: 'english_buddy',
		title: 'English buddy <br><br> Feature-rich vk-bot for learning English',
		thumb: {
			imagePath: {
				path: './media/projects/english_buddy/main.jpg',
				format: 'jpg',
				webp: './media/projects/english_buddy/main.webp',
			},
			imageFit: 'cover',
			imagePosition: 'center',
			imageAlt: 'English Buddy bot',
		},
	},
	{
		projectName: 'pizza_app',
		title: 'Pizza app <br><br> React pizza ordering application',
		thumb: {
			oldgen: {
				small: './media/projects/pizza_app/thumbs/small.jpg',
				medium: './media/projects/pizza_app/thumbs/medium.jpg',
				large: './media/projects/pizza_app/thumbs/large.jpg',
				format: 'jpg',
			},
			nextgen: {
				small: './media/projects/pizza_app/thumbs/small.webp',
				medium: './media/projects/pizza_app/thumbs/medium.webp',
				large: './media/projects/pizza_app/thumbs/large.webp',
			},
			imageFit: 'contain',
			imagePosition: 'center',
			imageAlt: 'Pizza application',
		},
	},
	{
		projectName: 'auto21',
		title:
			'Auto service website <br><br>Design and responsive layout using BEM methodology',
		thumb: {
			imagePath: {
				path: './media/projects/auto21/main.jpg',
				format: 'jpg',
				webp: './media/projects/auto21/main.webp',
			},
			imageFit: 'fill',
			imageAlt: 'autoservice web-site',
		},
	},
	{
		projectName: 'sedona',
		title: 'Sedona <br><br>Responsive layout using BEM methodology',
		thumb: {
			imagePath: {
				path: './media/projects/sedona/main.jpg',
				format: 'jpg',
				webp: './media/projects/sedona/main.webp',
			},
			imageFit: 'fill',
			imageAlt: 'Sedona web-site',
		},
	},
	{
		projectName: 'gllacy',
		title: 'Gllacy Shop <br><br>Layout for an attractive design',
		thumb: {
			imagePath: {
				path: './media/projects/gllacy/main.jpg',
				format: 'jpg',
				webp: './media/projects/gllacy/main.webp',
			},
			imageFit: 'fill',
			imageAlt: 'Gllacy attractive layout',
		},
	},

	{
		projectName: 'chat',
		title: 'The Simplest Daily Chat <br><br>Pure php + ajax',
		thumb: {
			imagePath: {
				path: './media/projects/chat/main.jpg',
				format: 'jpg',
				webp: './media/projects/chat/main.webp',
			},
			imageFit: 'fill',
			imageAlt: 'Ajax Chat',
		},
	},
	{
		projectName: 'snake',
		title: 'Canvas snake game <br><br>Javascript + canvas.js',
		thumb: {
			imagePath: {
				path: './media/projects/snake/main.png',
				format: 'png',
				webp: './media/projects/snake/main.webp',
			},
			imageFit: 'contain',
			imageAlt: 'Traditional snake screamer game',
		},
	},
	{
		projectName: 'vue-stock',
		title: 'Vue.js stock trader project<br><br>SPA with VueX &amp; Vue-Router',
		thumb: {
			imagePath: {
				path: './media/projects/vue-stock/main.png',
				format: 'png',
				webp: './media/projects/vue-stock/main.webp',
			},
			imageFit: 'fill',
			imageAlt: 'Vue.js trader app',
		},
	},
];

export default projectsDemos;
